import { render } from "./activityWrite.vue?vue&type=template&id=836c94e4&ts=true"
import script from "./activityWrite.vue?vue&type=script&lang=ts&config=true"
export * from "./activityWrite.vue?vue&type=script&lang=ts&config=true"

import "./activityWrite.vue?vue&type=style&index=0&id=836c94e4&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__